import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";

type UpdateKategoriBody = {
    id: number | string;
    namaKategori: string;
};

const updateKategori = async ({ id, namaKategori }: UpdateKategoriBody) => {
    const response = await axios.put(`/api/kategori/${id}`, { namaKategori });
    return response.data;
};

export default function useUpdateKategori() {
    const queryClient = useQueryClient();

    return useMutation(
        (body: UpdateKategoriBody) => updateKategori(body),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(["kategori", "list"]);
            },
        },
    );
}
